import { AxiosRequestConfig } from 'axios'

import { CreateVisitPromotionPayload, UpdateVisitPromotionPayload } from './types'

const getVisitPromotions = (): AxiosRequestConfig => ({
  url: '/visit-promotions',
  method: 'GET',
})

const createVisitPromotion = (promotion: CreateVisitPromotionPayload): AxiosRequestConfig => ({
  url: '/visit-promotions',
  method: 'POST',
  data: { promotion },
})

const updateVisitPromotion = (promotion: UpdateVisitPromotionPayload): AxiosRequestConfig => ({
  url: `/visit-promotions/${promotion.id}`,
  method: 'PUT',
  data: {
    promotion: {
      title: promotion.title,
      startTime: promotion.startTime,
      endTime: promotion.endTime,
      visitsToAdd: promotion.visitsToAdd,
      enabled: promotion.enabled,
    },
  },
})

const deleteVisitPromotion = (id: number): AxiosRequestConfig => ({
  url: `/visit-promotions/${id}`,
  method: 'DELETE',
})

export { getVisitPromotions, createVisitPromotion, updateVisitPromotion, deleteVisitPromotion }
